import { render, staticRenderFns } from "./RemainPvChart.vue?vue&type=template&id=4b452fe8&scoped=true"
import script from "./RemainPvChart.vue?vue&type=script&lang=js"
export * from "./RemainPvChart.vue?vue&type=script&lang=js"
import style0 from "./RemainPvChart.vue?vue&type=style&index=0&id=4b452fe8&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b452fe8",
  null
  
)

export default component.exports